import React, { useState, useEffect } from 'react'
import listTypes from '../api/listTypes'
import Select from 'react-select'

export default function ListEventType({ value, onChange, defaultOptions }: {
    value: string | undefined,
    onChange: (value: string | undefined) => void
    defaultOptions?: string[]
}) {
    const [options, setOptions] = useState<string[]>([])

    useEffect(() => {
        if (defaultOptions)
            setOptions(defaultOptions)
        else
            listTypes().then(newOptions => setOptions(newOptions))
    }, [])


    return <Select key={"list-eventtypes"} value={{
        label: value,
        value: value,
    }} options={options.map(option => ({ value: option, label: option }))}
        onChange={({ value, label }) => {
            if (!!value && !!label) {
                onChange(value)
            } else {
                onChange(undefined)
            }
        }}
    />
}